import produce from 'immer';
import { useEffect, useReducer } from 'react';

const UPDATE_SINGLE = Symbol('Update single');
const UPDATE_ALL = Symbol('Update all');
const INIT_LIST = Symbol('Init list');

const INITIAL_STATE = { options: {}, selected: new Set(), countSelected: 0, hasSelected: false, allSelected: false };

const reducer = produce((draft, { type, data }) => {
  const { options } = draft;
  switch (type) {
    case UPDATE_SINGLE:
      options[data.id] = data.value;
      break;
    case UPDATE_ALL:
      Object.keys(options).forEach((i) => {
        options[i] = data.value;
      });
      break;
    case INIT_LIST: {
      const result = {};
      data.list.forEach((id) => {
        result[id] = options[id] || false;
      });
      draft.options = result;
      break;
    }
    default:
      break;
  }
  const selectedList = Object.keys(options).filter((o) => options[o]).map(Number);
  draft.selectedString = selectedList.join(',');
  draft.selected = new Set(selectedList);
  draft.countSelected = draft.selected.size;
  draft.hasSelected = draft.countSelected > 0;
  draft.allSelected = draft.countSelected > 0 && Object.values(options).every(Boolean);
});

function useCheckbox(items) {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  function onCheck(ev, id) {
    const value = ev.target.checked;
    if (id) {
      dispatch({ type: UPDATE_SINGLE, data: { id, value } });
    } else {
      dispatch({ type: UPDATE_ALL, data: { value } });
    }
  }

  useEffect(() => {
    if (!items.list) {
      return;
    }
    dispatch({ type: INIT_LIST, data: items });
  }, [items.list]);

  return { onCheck, ...state };
}

export default useCheckbox;
